"use client";

import { Card, CardTitle } from "@/components/ui/card";
import React, { useState } from "react";
import PollCard from "./PollCard";
import { api } from "@/lib/trpc/client";
import { Button } from "@/components/ui/button";
import PollResultsDialog from "./PollResultsDialog";
import HoverableCard from "@/app/dashboard/polls/view/components/HoverableCard";
import { useLocale, useTranslations } from "use-intl";
import type { translations } from "@/messages";
import { useRouter } from "next/navigation";
import ShareDialog from "@/components/poll-system/ShareDialog";
type InstitutionPollListProps = {
  institutionSlug: string;
};
const InstitutionPollList = ({
  institutionSlug
}: InstitutionPollListProps) => {
  const t = useTranslations();
  const router = useRouter();
  const polls = api.pollSystemRouter.getPollsForInstitution.useInfiniteQuery({
    institutionSlug
  }, {
    getNextPageParam: lastPage => lastPage.nextCursor
  });
  const pollData = (polls?.data?.pages?.flatMap(page => page.data) || []).map(poll => ({
    ...poll,
    endDate: new Date(poll.endDate).toISOString(),
    startDate: new Date(poll.startDate).toISOString()
  }));
  type GroupedPollData = {
    [key: string]: {
      adminLevel: number;
      polls: typeof pollData;
    };
  };
  const groupedPollData: GroupedPollData = pollData.reduce((acc: GroupedPollData, poll) => {
    const regionName = poll.region?.name || "Unknown";
    const adminLevel = poll.region?.adminLevel || 0;
    if (!acc[regionName]) {
      acc[regionName] = {
        adminLevel,
        polls: []
      };
    }
    acc[regionName].polls.push(poll);
    return acc;
  }, {});
  const sortedRegions = Object.entries(groupedPollData).sort((a, b) => b[1].adminLevel - a[1].adminLevel);
  const handleCardClick = (pollId: string) => {
    const currentUrlRelativePath = window.location.pathname;
    console.log(`${currentUrlRelativePath}/${pollId}`);
    router.push(`${currentUrlRelativePath}/${pollId}`);
  };
  const [isShareDialogOpen, setIsShareDialogOpen] = useState(false);
  const [shareDialogData, setShareDialogData] = useState<{
    pollId: string;
    isPublic: boolean;
    minimumVotes: number | undefined;
  } | null>(null);
  return <div data-sentry-component="InstitutionPollList" data-sentry-source-file="InstitutionPollList.tsx">
      {sortedRegions.map(([regionName, {
      polls: regionPolls
    }]) => {
      return <div key={regionName} className="mb-10 w-full">
            <div className="relative flex">
              <h2 className="mb-2 text-xl font-semibold uppercase">{regionName}</h2>
            </div>
            <div className={`grid w-full grid-cols-1 gap-4 overflow-visible ${regionPolls.length === 0 ? "tablet:grid-cols-1" : "mt-4 tablet:grid-cols-2 desktop:grid-cols-3"}`}>
              {regionPolls.length > 0 ? regionPolls.map(poll => <HoverableCard key={poll.id} poll={{
            ...poll,
            startDate: poll.startDate.toString(),
            endDate: poll.endDate.toString()
          }} onClick={() => handleCardClick(poll.id)} onShare={() => {
            setIsShareDialogOpen(true);
            setShareDialogData({
              pollId: poll.id,
              isPublic: poll.isPublic,
              minimumVotes: undefined
            });
          }} />) : <Card className="w-full rounded-3xl p-8">
                  <p className="col-span-full text-center opacity-70">
                    {t("src_app_uat_institutionSlug_transparency_polls_components_InstitutionPollList_tsx_0")}
                  </p>
                </Card>}
            </div>
          </div>;
    })}
      <ShareDialog isOpen={isShareDialogOpen} onOpenChange={setIsShareDialogOpen} isPublic={shareDialogData?.isPublic || false} minimumVotes={shareDialogData?.minimumVotes} pollId={shareDialogData?.pollId || undefined} data-sentry-element="ShareDialog" data-sentry-source-file="InstitutionPollList.tsx" />
    </div>;
};
export default InstitutionPollList;